import React, { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { holdOrderAction } from '../../../redux/actions/orderActions'

const OrderForm = ({ order }) => {
    const dispatch = useDispatch()
    const [hold_reason, setHold_reason] = useState('')

    const displayID = String((order?.id)).padStart(6, '0');

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!hold_reason) {
            toast.error("Please fill in all required fields");
            return;
        }

        const myform = new FormData()
        myform.append("hold_reason", hold_reason)
        myform.append("order_id", order.id)

        dispatch(holdOrderAction(myform))
    }

    const handleReset = () => {
        setHold_reason('')
    }

    return (
        <Fragment>
            <form onSubmit={handleSubmit} className="w-full max-w-2xl space-y-6">
                {/* Metadata Badges */}
                <div className="flex flex-wrap gap-4 mb-6">
                    <div className="bg-indigo-50 px-4 py-2 rounded-lg flex items-center gap-2 border border-indigo-100">
                        <span className="text-sm font-semibold text-indigo-600 uppercase tracking-wider">Order ID:</span>
                        <span className="text-base font-bold text-indigo-900 font-mono">{displayID}</span>
                    </div>
                    <div className="bg-emerald-50 px-4 py-2 rounded-lg flex items-center gap-2 border border-emerald-100">
                        <span className="text-sm font-semibold text-emerald-600 uppercase tracking-wider">Order Number:</span>
                        <span className="text-base font-bold text-emerald-900 font-mono">{order?.order_number}</span>
                    </div>
                </div>

                {/* Input Field */}
                <div className="flex flex-col space-y-2">
                    <label className="text-sm font-bold text-gray-700 uppercase tracking-wide flex items-center gap-1">
                        Reason for Being On Hold
                        <span className="text-red-500">*</span>
                    </label>
                    
                    <div className="relative group">
                        <textarea
                            rows="6"
                            placeholder="Please provide a detailed reason for putting this order on hold..."
                            className="w-full px-5 py-4 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 transition-all duration-300 text-gray-800 text-base font-medium resize-none"
                            value={hold_reason}
                            onChange={(e) => setHold_reason(e.target.value)}
                        />
                        <div className="absolute right-4 bottom-4 text-xs text-gray-400 font-medium bg-white px-2 py-1 rounded-md border border-gray-100 shadow-sm">
                            {hold_reason.length} characters
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="flex items-center justify-start gap-4 pt-4">
                    <button
                        type="button"
                        onClick={handleReset}
                        className="px-6 py-3 border border-gray-300 text-gray-600 rounded-xl font-bold text-sm uppercase tracking-wider hover:bg-gray-50 hover:border-gray-400 transition-all duration-300"
                    >
                        Reset
                    </button>
                    <button
                        type="submit"
                        className="px-8 py-3 bg-gradient-to-r from-indigo-600 to-indigo-700 text-white rounded-xl font-bold text-sm uppercase tracking-wider shadow-lg shadow-indigo-200 hover:shadow-indigo-300 hover:translate-y-[-2px] active:translate-y-[0px] transition-all duration-300 flex items-center gap-2"
                    >
                        <i className="fa-solid fa-circle-check"></i>
                        Submit
                    </button>
                </div>
            </form>
        </Fragment>
    )
}

export default OrderForm